import adminAPI from '../services/adminApi';

export async function fetchUserNameMap(userIds) {
  if (!userIds || userIds.length === 0) return {};
  try {
    const res = await adminAPI.getAssignableUsers({ ids: userIds.join(','), limit: 100 });
    const users = res?.data?.data?.users || res?.data?.users || [];
    const map = {};
    userIds.forEach(id => {
      const u = users.find(u => String(u._id || u.id) === id);
      if (u) map[id] = `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email || '';
    });
    return map;
  } catch (e) {
    console.warn('[fetchUserNameMap]', e.message);
    return {};
  }
}

export function openBlob(base64) {
  const decoded = atob(base64);
  const bytes = Uint8Array.from(decoded, c => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: 'text/html; charset=utf-8' });
  window.open(URL.createObjectURL(blob), '_blank');
}
